import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["referencedObjectType"];
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import { OrderedSet } from 'immutable';
import Equal from '../operator/Equal';
import FieldDefinitionRecord from './FieldDefinitionRecord';
import Known from '../operator/Known';
import NotEqual from '../operator/NotEqual';
import NotKnown from '../operator/NotKnown';
import invariant from 'react-utils/invariant';
export const makeReferenceIdFieldDefinition = options => {
  const {
      referencedObjectType
    } = options,
    rest = _objectWithoutPropertiesLoose(options, _excluded);
  invariant(referencedObjectType, 'Reference Id fields require a referencedObjectType');
  return FieldDefinitionRecord(Object.assign({}, rest, {
    inputType: ENUMERATION,
    operators: OrderedSet.of(Equal, NotEqual, Known, NotKnown),
    referencedObjectType
  }));
};